import { useBaseOneActions } from '../base.actionsOne';

function useEventosActions() {
  const baseActions = useBaseOneActions('evento');

  return {
    get: baseActions.get,
    list: baseActions.list,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };
}

export { useEventosActions };
